import { SocketContext } from '../context/SocketContext';
import { useContext, useState } from 'react';

export const useSocket = () => {
    const context = useContext(SocketContext);
    return context;
};
